import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useBrand(userId) {
  const { data, _error, mutate } = useSWR(
    userId ? `/brands/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    brand: data,
    mutate: mutate,
  };
}

export default useBrand;
